import { render, staticRenderFns } from "./crew-advtrxhist.vue?vue&type=template&id=44583199&scoped=true"
import script from "./crew-advtrxhist.vue?vue&type=script&lang=js"
export * from "./crew-advtrxhist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44583199",
  null
  
)

export default component.exports